import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { TopHeaderComponent } from "./components/top-header/top-header.component";
import { PreloaderComponent } from "./components/preloader/preloader.component";
import { HomeComponent } from "./home/home.component";
import { ResearchComponent } from "./research/research.component";
import { PublicationsComponent } from "./publications/publications.component";
import { ContactComponent } from "./contact/contact.component";
import { FooterComponent } from "./components/footer/footer.component";

import { environment } from "src/environments/environment";
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { FirebaseService } from "./components/firebase-service/firebase-service.service";
import { NewsListComponent } from "./news-list/news-list.component";
import { PeopleComponent } from "./people/people.component";

import { AngularOpenlayersModule } from "ngx-openlayers";
// Import ngx-twitter-timeline
import { NgxTwitterTimelineModule } from "ngx-twitter-timeline";
import { AnalyticsService } from "./components/analytics-service/analytics.service";
import { PortfolioComponent } from "./portfolio/portfolio.component";

import { ModalModule } from "ngx-bootstrap";
import { DeviceDetectorModule } from "ngx-device-detector";
import { SafeHtmlPipe } from "./components/safe-html-pipe/safe-html.pipe";

import { NgxPageScrollCoreModule } from "ngx-page-scroll-core";
import { NgxPageScrollModule } from "ngx-page-scroll";

import { CarouselModule } from "ngx-bootstrap/carousel";
import { GalleryComponent } from "./components/gallery/gallery.component";

@NgModule({
  declarations: [
    AppComponent,
    TopHeaderComponent,
    PreloaderComponent,
    HomeComponent,
    PeopleComponent,
    NewsListComponent,
    ResearchComponent,
    PublicationsComponent,
    ContactComponent,
    FooterComponent,
    PortfolioComponent,
    SafeHtmlPipe,
    GalleryComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularOpenlayersModule,
    NgxTwitterTimelineModule,
    ModalModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    NgxPageScrollModule,
    NgxPageScrollCoreModule.forRoot({ duration: 500, scrollOffset: 20 }),
    CarouselModule.forRoot(),
  ],
  providers: [FirebaseService, AnalyticsService],
  bootstrap: [AppComponent],
})
export class AppModule {}
